import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_ADMIN_UPDATE_TWILIO_PHONE_NUMBER,
  SR_API_ACTION_ADMIN_GET_TWILIO_PHONE_NUMBER,
} from 'api/actionTypes';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

import { createFormValidationFn } from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';

class SrAdminTwilioPhoneForm extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    twilioPhoneKey: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor() {
    super();

    this.state = {
      twilioPhoneNumber: '',
    };
  }

  componentDidMount() {
    const { dispatch, twilioPhoneKey } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_GET_TWILIO_PHONE_NUMBER,
      queryId: twilioPhoneKey,
      payload: {
        twilioPhoneKey,
      },
    }).then((twilioPhoneNumber) => {
      this.setState({ twilioPhoneNumber });
    });
  }

  _onSubmit = ({ twilioPhoneNumber }) => {
    const { dispatch, twilioPhoneKey } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_TWILIO_PHONE_NUMBER,
      payload: {
        twilioPhoneNumber,
        twilioPhoneKey,
      },
    });
  }

  render() {
    const { title } = this.props;
    const { twilioPhoneNumber } = this.state;
    const formField = {
      id: 'twilioPhoneNumber',
      label: title,
      validations: ['phone'],
      type: 'phone',
    };

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            twilioPhoneNumber: twilioPhoneNumber || '',
          }}
          validate={createFormValidationFn([formField])}
          onSubmit={this._onSubmit}
          render={(formikBag) => (
            <Form>
              <SrFormikField
                formikBag={formikBag}
                formField={formField}
              />
              <ButtonDeprecated
                type='submit'
                disabled={!formikBag.isValid}
              >
                Update
              </ButtonDeprecated>
            </Form>
          )}
        />
      </div>
    );
  }
}

SrAdminTwilioPhoneForm.displayName = SrAdminTwilioPhoneForm;

export default SrAdminTwilioPhoneForm;
